const FILTER_ADMIN_HTML_BASE_URL =
  process.env.REACT_APP_FILTER_ADMIN_HTML_BASE_URL || 'http://localhost:3000';

const config = {
  app: {
    name: process.env.REACT_APP_SHOPIFY_APP_NAME,
    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
    appScope: [
      // Required access scopes for filter app -----------------------------
      'read_products',
      'read_orders',
      'read_themes',
      'read_content',
      'write_themes',
      'read_locales',
      'read_translations',
      'read_locations',
      'read_inventory',
      // access scope to sync data for product field published_scope in graphql
      'read_publications',
      'read_shipping',
      // storefront api
      'unauthenticated_read_product_inventory',
      'unauthenticated_read_product_listings',
      // new access scopes (for recommendation)
      'read_all_orders',
      // B2b
      'read_markets',


      // Optional access scopes ---------------------------
      // Optional access scopes for better experience, but not required for app approval, merchants can choose to grant these permissions when installing the app or updating permissions later
      // b2b
      'read_customers',

      // new access scopes (for bundle)
      'read_discounts',
      'write_discounts',

      // access scopes for pre-order
      'write_purchase_options',
      'write_products',
      'write_orders', // access scopes for update pre-order tag

      // metaobjects
      'read_metaobjects',
      'read_metaobject_definitions'
    ].join(', '),
    nonce: 'bcfilter@2016',
    installCallbackUrl: `${FILTER_ADMIN_HTML_BASE_URL}/oauth/finalize`,
    updatePermissionCallbacklUrl: `${FILTER_ADMIN_HTML_BASE_URL}/update-permission-success`
  },
  api: {
    adminURL: process.env.REACT_APP_ADMIN_V2_BASE_URL,
    syncURL: process.env.REACT_APP_SYNC_V2_BASE_URL
  },
  site: {
    syncStatusTimeout: 5000,
    lastSyncTimeout: 180000, // 3 mins
    showSyncProgressTimeout: 10000
  },
  integrations: {
    fullStory: {
      orgId: process.env.REACT_APP_FULLSTORY_ORG_ID,
      debug: process.env.NODE_ENV !== 'production',
      devMode: process.env.NODE_ENV !== 'production'
    }
  },
  simulator: {
    // Hosts allowed to postMessage an auth0Token into the /oauth iframe (see oauth.jsx)
    referrerHosts: (process.env.REACT_APP_SIMULATOR_REFERRER_HOSTS || '')
      .split(',')
      .map(host => host.trim())
      .filter(Boolean)
  }
};

module.exports = config;
